// extracted by mini-css-extract-plugin
module.exports = {"menu-sub-item":"style_menu-sub-item__2xf4L","separate":"style_separate__2Peq-","menu-sub-item-icon":"style_menu-sub-item-icon__34Qvc"};